import { makeStyles } from "@material-ui/core";
import { Box, Divider, Typography } from "@mui/material";
import MuiButton from "@mui/material/Button";
import { styled, useTheme } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useEffect, useState } from "react";
import logo from "src/assets/favicon.png";
import { setGimmickyInStore } from "src/slices/bkvReducer";
import { useDispatch, useSelector } from "src/store";
import icircle from "../icons/triangle-exclamation.svg";
import xcircle from "../icons/xmark-circle.svg";
import questionMark from "../images/info-icon.png";
import CompetitorList from "./CompetitorList";
import SavingsComponent from "./SavingsComponent";
import SimpleText from "./SimpleText";
import { GimmickyType } from "./types/plans";
import { useComparisonLogic } from "./useComparisonLogic";
import RateGraph from "./widgets/RateGraph";

interface PlanPrices {
  price500: number;
  price1000: number;
  price1500: number;
  price2000: number;
  price2500: number;
}

export interface CompetitorType {
  Provider_name: string;
  Plan_id: string;
  Contract_term: string;
  Price500: string;
  Price1000: string;
  Price2000: string;
  Tiers: string;
  [key: string]: any;
}

let listId = "";
let type = "";
let selected = false;

const simpleTextStyleObj = {
  fontSize: {
    xs: "14px",
    md: "3.3vw",
    lg: "20px",
  },
  color: "#2f2f2f",
};

const BullseyeGraph = ({ content, handleOpen, showCompetitorTable, type }) => {
  const { handleComparisonLogic } = useComparisonLogic();
  const theme = useTheme();
  const isPad = useMediaQuery("(max-width:900px)");
  const [someParams, setSomeParams] = useState(true);
  const state = useSelector((state) => state.bkv);
  const [graphData, setGraphData] = useState([]);
  const [custPlan, setCustPlan] = useState({});
  // const [type, setType] = useState("");
  const [selectedList, setSelectedList] = useState(false);
  const dispatch = useDispatch();
  const sm = useMediaQuery("max-width: 960px");
  const classes = useStyles();
  const [productId, setProductId] = useState("");
  const Button = styled(MuiButton)((props) => ({
    borderRadius: "10vw",
    whiteSpace: "nowrap",
  }));

  const [competitiorArray, setCompetitorArray] = useState([]);

  const handleSelectPlan = (plan, key) => {
    let rateArr = [500, 1000, 1500, 2000, 2500].map((kwh) => {
      let rate;
      switch (kwh) {
        case 500:
          rate = Number(
            parseFloat(state.bluebonnet?.Pricing[0].kWh500).toFixed(2) || 0
          );
          break;
        case 1000:
          rate = Number(
            parseFloat(state.bluebonnet?.Pricing[0].kWh1000).toFixed(2) || 0
          );
          break;
        case 2000:
          rate = Number(
            parseFloat(state.bluebonnet?.Pricing[0].kWh2000).toFixed(2) || 0
          );
          break;
        default:
          rate = Number(
            parseFloat(state.bluebonnet?.Pricing[0].kWh2000).toFixed(2) || 0
          );
      }
      return {
        gimmicky: plan[`${key}${kwh}`],
        bluebonnet: rate,
        kwh: kwh,
      };
    });
    setGraphData(rateArr);
  };

  useEffect(() => {
    if (state.gimmicky) {
      // console.log("state.gimmicky")
      const compareType =
        content?.details?.description[0]?.graph_text.match(/vs\. (.*)/)[1];

      handleComparisonLogic(compareType);
      handleSelectPlan(state.gimmicky, "kWh");
    } else {
      // console.log('only bluebonnet')
      let rateArr = [500, 1000, 1500, 2000, 2500].map((kwh) => {
        let rate;
        switch (kwh) {
          case 500:
            rate = Number(
              parseFloat(state.bluebonnet?.Pricing[0].kWh500).toFixed(2) || 0
            );
            break;
          case 1000:
            rate = Number(
              parseFloat(state.bluebonnet?.Pricing[0].kWh1000).toFixed(2) || 0
            );
            break;
          case 2000:
            rate = Number(
              parseFloat(state.bluebonnet?.Pricing[0].kWh2000).toFixed(2) || 0
            );
            break;
          default:
            rate = Number(
              parseFloat(state.bluebonnet?.Pricing[0].kWh2000).toFixed(2) || 0
            );
        }
        return {
          bluebonnet: rate,
          kwh: kwh,
        };
      });
      setGraphData(rateArr);
    }
  }, [state.gimmicky]);

  const handleSelectCompetitor = (plan: CompetitorType) => {
    selected = true;
    let newGimmicky: GimmickyType = {
      ProductId: plan?.Plan_id,
      Title: plan?.Provider_name,
      Terms: Number(plan?.Contract_term),
      kWh500: Number(plan?.Price500),
      kWh1000: Number(plan?.Price1000),
      kWh1500: Number(plan?.Price1000),
      kWh2000: Number(plan?.Price2000),
      kWh2500: Number(plan?.Price2000),
      Tiers: plan?.Tiers,
    };
    listId = plan?.Plan_id;

    dispatch(setGimmickyInStore(newGimmicky));
  };

  const setPlanType = (plan: CompetitorType) => {
    let str = String(plan?.Plan_name);
    if (state.type === "bluebonnet-vs-free-nights-weekends") {
      if (str.includes("Weekends")) {
        type = "bluebonnet-vs-free-weekends";
      } else {
        type = "bluebonnet-vs-free-nights";
      }
    } else {
      type = state.type;
    }
  };

  useEffect(() => {
    if (!selected) {
      setPlanType(state.competitorArray[0]);
    }
  }, [state.competitorArray]);
  console.log(showCompetitorTable);
  const compareType =
    content?.details?.description[0]?.graph_text.match(/vs\. (.*)/)[1];
  const isBKVE = BooleanBKVE(compareType);

  if (
    Object.values(state.usage).length &&
    state.gimmicky &&
    !state.showRateGraph
  ) {
    return (
      <SavingsComponent
        content={content}
        handleOpen={(key) => handleOpen(key)}
      />
    );
  } else {
    return (
      <Box
        sx={{
          padding: "1% 3% 1% 3%",
          display: "flex",
          gap: "26px",
          flexDirection: {
            xs: "column",
            sm: "column",
            md: "column",
            lg: "row-reverse",
          },
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {!showCompetitorTable ? (
          <Box
            sx={{
              border: `2px ${theme.palette.secondary.light} solid`,
              height: { xs: "auto", sm: "auto", md: "auto", lg: "528px" },
              width: { xs: "90%", sm: "90%", md: "90%", lg: "46%" },
              borderRadius: { xs: "3vw", sm: "3vw", md: "3vw", lg: "20px" },
              display: "flex",
              flexDirection: "column",
              padding: "18px",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                padding: "5% 0%",
                display: "flex",
                flexDirection: "row",
                // justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                width={{ xs: "15%", sm: "15%", md: "30px", lg: "30px" }}
                m={{ xs: "0 5%", sm: "0 5%", md: "0 3%", lg: "0 5%" }}
              >
                <img width="20px" src={xcircle} />
              </Box>
              <SimpleText
                style={simpleTextStyleObj}
                text={content?.details?.description[0]?.content1}
              />
            </Box>
            <Divider sx={{ bgcolor: theme.palette.secondary.light }} />
            <Box
              sx={{
                padding: "5% 0%",
                display: "flex",
                flexDirection: "row",
                // justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                width={{ xs: "15%", sm: "15%", md: "30px", lg: "30px" }}
                m={{ xs: "0 5%", sm: "0 5%", md: "0 3%", lg: "0 5%" }}
              >
                <img width="20px" src={xcircle} />
              </Box>
              <SimpleText
                style={simpleTextStyleObj}
                text={content?.details?.description[0]?.content2}
              />
            </Box>
            <Divider sx={{ bgcolor: theme.palette.secondary.light }} />
            <Box
              sx={{
                padding: "5% 0%",
                display: "flex",
                flexDirection: "row",
                // justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                width={{ xs: "15%", sm: "15%", md: "30px", lg: "30px" }}
                m={{ xs: "0 5%", sm: "0 5%", md: "0 3%", lg: "0 5%" }}
              >
                <img width="20px" src={xcircle} />
              </Box>
              <SimpleText
                style={simpleTextStyleObj}
                text={content?.details?.description[0]?.content3}
              />
            </Box>
            <Divider sx={{ bgcolor: theme.palette.secondary.light }} />
            <Box
              sx={{
                padding: "5% 0%",
                display: "flex",
                flexDirection: "row",
                // justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                width={{ xs: "15%", sm: "15%", md: "30px", lg: "30px" }}
                m={{ xs: "0 5%", sm: "0 5%", md: "0 3%", lg: "0 5%" }}
              >
                <img width="20px" src={icircle} />
              </Box>
              <SimpleText
                style={simpleTextStyleObj}
                text={content?.details?.graph?.info}
              />
            </Box>
          </Box>
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "48px",
                }}
              >
                <Typography
                  fontSize="20px"
                  variant="body1"
                  color="#09507F"
                  fontWeight="600"
                  mr="10px"
                >
                  {content?.details?.description[0]?.text}{" "}
                </Typography>{" "}
                <Tooltip
                  componentsProps={{
                    tooltip: {
                      sx: {
                        bgcolor: "#cecece",
                        fontSize: "15px",
                        borderRadius: "10px",
                        padding: "10px",
                        width: "50vw",
                        "& .MuiTooltip-arrow": {
                          color: "common.black",
                        },
                      },
                    },
                  }}
                  className={classes.tooltip}
                  title="Data incorporated into this table is pulled daily from all Texas retail energy providers and calculates real time prices differences and savings."
                  placement="top"
                >
                  <img
                    src={questionMark}
                    alt="i"
                    style={{ height: "20px", cursor: "pointer" }}
                  />
                </Tooltip>
              </Box>

              <CompetitorList
                handleSelectCompetitor={handleSelectCompetitor}
                setPlanType={setPlanType}
              />
            </Box>
          </>
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            width: { xs: "100%", sm: "100%", md: "100%", lg: "50%" },
            marginTop: { xs: "3%", lg: "0" },
            marginBottom: { xs: "15%", lg: "0" },
          }}
        >
          <>
            {graphData && graphData?.[0]?.gimmicky && (
              <>
                <Typography
                  fontSize="20px"
                  variant="body1"
                  color="#09507F"
                  fontWeight="600"
                  // lineHeight="0"
                  align="center"
                  height="48px"
                >
                  {content?.details?.description[0]?.graph_text}
                </Typography>

                <Box
                  id="bullseye-graph"
                  sx={{
                    marginLeft: { lg: "2%" },
                    marginTop: "0",
                    marginRight: "2.5rem",
                    border: `1px ${theme.palette.secondary.light} solid`,
                    background: "#E5F5F3",
                    height: {
                      xs: "max-content",
                      sm: "max-content",
                      md: "max-content",
                      lg: "500px",
                    },
                    // width: { xs: "90%", sm: "90%", md: "90%", lg: "50%" },
                    width: "92%",
                    borderRadius: {
                      xs: "3vw",
                      sm: "3vw",
                      md: "3vw",
                      lg: "20px",
                    },
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    padding: "10px 20px",
                    position: "relative",
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: "2%",
                      left: "5%",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "90%",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box
                        sx={{
                          height: "10px",
                          width: "10px",
                          backgroundColor: "#33AEA0",
                          marginRight: "10px",
                        }}
                      ></Box>
                      <Typography sx={{ marginRight: "5px" }}>
                        {isBKVE ? "Bluebonnet" : "BKVE Bluebonnet"}{" "}
                      </Typography>
                      <img
                        src={logo}
                        alt="logo"
                        width={20}
                        height={20}
                        style={{ marginBottom: "10px" }}
                      />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                      ml="10%"
                    >
                      <Box
                        sx={{
                          height: "10px",
                          width: "10px",
                          backgroundColor: "#CCCCCC",
                          marginRight: "10px",
                        }}
                      ></Box>
                      <Typography sx={{ marginRight: "5px" }}>
                        {isBKVE
                          ? compareType
                          : `Competitor ${compareType} Plan`}{" "}
                      </Typography>
                    </Box>
                  </Box>
                  <RateGraph dataKey="kwh" data={graphData} type={type} />
                </Box>
              </>
            )}
            {graphData && !graphData?.[0]?.gimmicky && (
              <>
                <Typography
                  fontSize="20px"
                  variant="body1"
                  color="#09507F"
                  fontWeight="600"
                  // lineHeight="0"
                  align="center"
                  height="48px"
                  margin={{ sm: "10px" }}
                >
                  The{" "}
                  {
                    content?.details?.description[0]?.graph_text.match(
                      /vs\. (.*)/
                    )[1]
                  }{" "}
                  plan is not currently available.
                  <br /> Please visit{" "}
                  <a href="https://enroll.bkvenergy.com">
                    enroll.bkvenergy.com
                  </a>{" "}
                  to explore other options in your area.
                </Typography>
              </>
            )}
          </>
        </Box>
      </Box>
    );
  }
};

export default BullseyeGraph;

const useStyles = makeStyles((theme) => ({
  button1: {
    transition: "all .1s ease-in-out",
    border: "3px solid #fff",
    "&:hover": {
      // transform: "scale(1.05, 1.05)",
      animation: "$scale .2s ease-in-out",
      background: "transparent",
    },
  },
  button2: {
    transition: "all .1s ease-in-out",
    border: "3px solid #FFD27D",
    "&:hover": {
      // transform: "scale(1.05, 1.05)",
      animation: "$scale .2s ease-in-out",
      background: "transparent",
    },
  },
  tooltip: {
    // position: "absolute",
    // top: "9%",
    // left: "19%",
    //  background: "rgb(237 237 237)",
  },
  "@keyframes scale": {
    "0%": {
      // transform: "scale(1.05, 1.05)",
      animation: "$scale .2s ease-in-out",
    },
    "50%": {
      transform: "scale(1.03, 1.03)",
    },
    "100%": {
      transform: "scale(1)",
    },
  },
}));

const BooleanBKVE = (val: string) => {
  const BKVE = ["Agave", "Polyedra", "Pepper Tree", "Primrose", "Paintbrush"],
    Competitor = [
      "Bullseye",
      "Base Fees",
      "Bill Credit",
      "Free Nights & Weekends",
      "EV Charging",
    ];

  if (BKVE.includes(val)) {
    return true;
  } else if (Competitor.includes(val)) {
    return false;
  } else {
    return false;
  }
};
